<template>
  <div>
    <spreadsheet key="budgetRestrictionsTable" v-model="data" :columns="columns" class="mt-2" @input="updatedSpreadsheet"/>
  </div>
</template>
<script>
import Spreadsheet from '@/components/ekrm/Spreadsheet.vue'
export default {
  data () {
    return {
      data: [],
      restrictionsChanges: {}
    }
  },
  computed: {
    columns () {
      return [
        { type: 'html', title: this.$t('components.BudgetRestrictionsTable.mediaChannel'), width: 250, align: 'left', readOnly: true, wordWrap: true },
        { type: 'text', title: this.$t('components.BudgetRestrictionsTable.min'), width: 130, allowNegatives: false, defaultEmptyValue: 0, disableDecimals: true },
        { type: 'text', title: this.$t('components.BudgetRestrictionsTable.max'), width: 130, allowNegatives: false, disableDecimals: true }
      ]
    }
  },
  methods: {
    updatedSpreadsheet () {
      this.restrictionsChanges = this.data.reduce((acc, curr, index) => {
        const [, ...values] = curr
        // Get key from this.channels to avoid pretty-name transformations
        acc[this.channels[index][0]] = values.map(value => {
          // Allow '' values (NaN or ''), because they represent open boundaries
          if (isNaN(value) || value !== '') {
            return Number(value)
          } else {
            return value
          }
        })
        return acc
      }, {})
      this.$emit('input', this.restrictionsChanges)
    }
  },
  watch: {
    channels: {
      immediate: true,
      handler () {
        this.data = this.channels.map(channel => [this.prettyNames && this.prettyNames[channel[0]] ? this.prettyNames[channel[0]] : channel[0], 0, ''])
      }
    },
    value: {
      immediate: true,
      handler () {
        if (this.value && this.channels) {
          this.data = this.channels.map(channel => {
            if (this.value[channel[0]]) {
              return [
                this.prettyNames && this.prettyNames[channel[0]] ? this.prettyNames[channel[0]] : channel[0],
                this.value[channel[0]][0],
                this.value[channel[0]][1]
              ]
            } else {
              return [this.prettyNames && this.prettyNames[channel[0]] ? this.prettyNames[channel[0]] : channel[0], 0, '']
            }
          })
        }
      }
    }
  },
  props: {
    value: {
      type: Object
    },
    channels: {
      type: Array,
      required: true
    },
    prettyNames: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    }
  },
  components: {
    Spreadsheet
  }
}
</script>
